import { COLORS } from '../utils/Application_Constants';

export default {
    variants: [
        {
            props: (props) => props.variant && props.variant.startsWith('lt-admin'),
            style: {
                '&.Mui-expanded': { margin: 0 },
                borderRadius: 5,
                '&:first-of-type': {
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5,
                },
                '&:last-of-type': {
                    borderBottomLeftRadius: 5,
                    borderBottomRightRadius: 5,
                },
                border: `1px solid ${COLORS.LT_MIDNIGHT10}`,
                boxShadow: 'none',
                overflow: 'hidden',

                '& .MuiAccordion-heading': {
                    '& .MuiAccordionSummary-root': {
                        padding: '14px 12px',
                        color: COLORS.LT_MIDNIGHT,
                        '& .MuiAccordionSummary-content': {
                            margin: 0,
                            '& .MuiTypography-root': { lineHeight: '20px' },
                        },
                        '& .MuiAccordionSummary-expandIconWrapper': {
                            color: COLORS.LT_MIDNIGHT,
                        },
                        '&.Mui-focusVisible': {
                            backgroundColor: 'transparent',
                        },

                        '&.Mui-expanded': {
                            '.MuiAccordionSummary-content': { margin: 0 },
                            '.MuiAccordionSummary-expandIconWrapper': {
                                color: COLORS.WHITE,
                            },
                            backgroundColor: COLORS.LT_JOURNEY,
                            color: COLORS.WHITE,
                            minHeight: 'fit-content',
                            margin: 0,
                            borderBottom: `1px solid ${COLORS.LT_MIDNIGHT10}`,
                        },
                    },
                },

                '& .MuiCollapse-root.MuiCollapse-vertical': {
                    '& .MuiAccordionDetails-root': {
                        padding: '15px 10px',
                    },
                },
            },
        },
        {
            props: { variant: 'lt-admin-primary' },
            style: ({ theme }) => ({
                backgroundColor: theme.palette.primary.main,
                border: `1px solid ${theme.palette.primary.main}`,
                borderRadius: `${theme.shape.borderRadiusVariants.md}px`,
                '&:first-of-type': {
                    borderTopLeftRadius: `${theme.shape.borderRadiusVariants.md}px`,
                    borderTopRightRadius: `${theme.shape.borderRadiusVariants.md}px`,
                },
                '&:last-of-type': {
                    borderBottomLeftRadius: `${theme.shape.borderRadiusVariants.md}px`,
                    borderBottomRightRadius: `${theme.shape.borderRadiusVariants.md}px`,
                },

                '& .MuiAccordion-heading': {
                    '& .MuiAccordionSummary-root': {
                        color: COLORS.WHITE,
                        backgroundColor: theme.palette.primary.main,
                        '& .MuiAccordionSummary-expandIconWrapper': {
                            color: COLORS.WHITE,
                        },

                        '&.Mui-expanded': {
                            '.MuiAccordionSummary-expandIconWrapper': {
                                color: COLORS.WHITE,
                            },
                            backgroundColor: theme.palette.primary.main,
                            color: COLORS.WHITE,
                            borderBottom: `1px solid ${theme.palette.primary.main}`,
                        },
                    },
                },

                '& .MuiAccordionDetails-root': {
                    backgroundColor: 'white',
                },
            }),
        },
    ],
};
